/**
 * Parses Blender RNA property paths used in drivers.
 *
 * The primary pattern for shape key drivers:
 *   key_blocks["<name>"].value → (shapeKeyName)
 *
 * Reference: docs/02-architecture.md "Property Path Resolution" section
 */

export interface ResolvedPath {
  type: "shape_key_value";
  keyName: string;
}

const SHAPE_KEY_REGEX = /^key_blocks\["(.+?)"\]\.value$/;

export function resolvePropertyPath(rnaPath: string): ResolvedPath | null {
  const match = rnaPath.match(SHAPE_KEY_REGEX);
  if (match) {
    return { type: "shape_key_value", keyName: match[1] };
  }
  return null;
}
